/* PES Kit Builder — client-side engine for sections/pes-kit-builder.liquid
 * Data: paced /collections/<handle>/products.json fetches (>=3s apart),
 * sessionStorage cache (slim product records). Presentation only — no catalog writes.
 */
(function () {
  if (window.PESKitBuilder) return;
  var root = document.getElementById('pes-kb');
  if (!root) return;

  /* ---------------- fetch infrastructure ---------------- */
  var CACHE_PREFIX = 'pesKitV1:';
  var PACE_MS = 3000;

  function u(handle, page) {
    return '/collections/' + handle + '/products.json?limit=250&page=' + (page || 1);
  }

  // Slim a raw products.json record down to what we need (keeps sessionStorage small).
  function slim(p) {
    return {
      title: p.title || '',
      handle: p.handle || '',
      vendor: p.vendor || '',
      pt: p.product_type || '',
      tags: (p.tags || []).map(function (t) { return String(t).toLowerCase(); }),
      img: (p.images && p.images[0] && p.images[0].src) ? p.images[0].src.replace(/\.(png|jpe?g|webp)/i, '_110x110_crop_center.$1') : '',
      vars: (p.variants || []).map(function (v) {
        return { id: v.id, title: v.title || '', price: parseFloat(v.price) || 0, sku: v.sku || '', avail: !!v.available };
      })
    };
  }

  var PROMISES = {};
  var queue = [];
  var running = false;
  var lastStart = 0;

  function get(url) {
    try {
      var c = sessionStorage.getItem(CACHE_PREFIX + url);
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}
    return fetch(url)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var ps = (d.products || []).map(slim);
        try { sessionStorage.setItem(CACHE_PREFIX + url, JSON.stringify(ps)); } catch (e) {}
        return ps;
      })
      .catch(function () { return []; });
  }

  function pump() {
    if (running) return;
    var job = queue.shift();
    if (!job) return;
    running = true;
    var wait = Math.max(0, PACE_MS - (Date.now() - lastStart));
    setTimeout(function () {
      lastStart = Date.now();
      get(job.url).then(function (d) {
        running = false; job.res(d); pump();
      });
    }, wait);
  }

  function fetchColl(url) {
    if (!PROMISES[url]) {
      PROMISES[url] = new Promise(function (res) { queue.push({ url: url, res: res }); pump(); });
    }
    return PROMISES[url];
  }

  function fetchSet(urls) {
    return Promise.all(urls.map(fetchColl)).then(function (arrs) {
      var out = [], seen = {};
      arrs.forEach(function (a) {
        a.forEach(function (p) { if (!seen[p.handle]) { seen[p.handle] = 1; out.push(p); } });
      });
      return out;
    });
  }

  var SETS = {
    panels: [u('400w-solar-panels'), u('430w-solar-panels'), u('450w-solar-panels'), u('550w-solar-panels')],
    inv: [u('microinverters'), u('microinverters', 2), u('solar-inverters'), u('solar-inverters', 2),
          u('sol-ark'), u('eg4-electronics'), u('solis'), u('fortress-power')],
    rack: [u('ironridge'), u('ironridge', 2), u('dpw-solar'), u('prosolar')],
    batt: [u('fortress-power'), u('battery-storage')]
  };

  // Kick off the whole paced prefetch chain immediately (panels first).
  var DATA = {};
  DATA.panels = fetchSet(SETS.panels);
  DATA.inv = fetchSet(SETS.inv);
  DATA.rack = fetchSet(SETS.rack);
  DATA.batt = fetchSet(SETS.batt);

  /* ---------------- classification ---------------- */
  var JUNK_VENDORS = { 'pes': 1, 'pes supply': 1, 'pes global': 1, 'unbound solar': 1, 'enf solar': 1 };

  function isJunk(p) {
    var v = (p.vendor || '').toLowerCase();
    if (JUNK_VENDORS[v]) return true;
    return p.tags.some(function (t) {
      return t.indexOf('gap-product') >= 0 || t.indexOf('competitor-match') >= 0 || t.indexOf('zero-price-fix') >= 0;
    });
  }

  function bestVariant(p) {
    var ok = p.vars.filter(function (v) { return v.avail && v.price > 0; });
    if (!ok.length) return null;
    for (var i = 0; i < ok.length; i++) if (/default title/i.test(ok[i].title)) return ok[i];
    return ok[0];
  }

  function parseWatts(t) {
    var m = t.match(/(\d{3,4})\s*(?:W|Watt)\b/i);
    return m ? +m[1] : 0;
  }

  function isPanel(p, tier) {
    if (isJunk(p)) return false;
    if ((p.pt || '').toLowerCase() !== 'solar panels') return false;
    if (/pallet|truckload|container/i.test(p.title)) return false;
    var w = parseWatts(p.title);
    if (!w) return false;
    if (tier && Math.abs(w - tier) > 12) return false;
    return !!bestVariant(p);
  }

  var INV_TYPES = ['solar inverters', 'inverters', 'string inverters', 'charge controllers'];
  var INV_ACC = /dongle|transmitter|combiner|bus\s?bar|cable|stick\b|data\s?log|wifi|cellular|rs485|connector|unlock|tool|cap\b|clip|bracket|mount|rail|\bkit\b|enclosure|cover|monitor|dtu|plug-?in|gateway|t-bolt|hardware|sealing|terminator|disconnect/i;

  function invClass(p) {
    if (isJunk(p)) return null;
    var pt = (p.pt || '').toLowerCase();
    if (INV_TYPES.indexOf(pt) < 0) return null;
    var t = p.title;
    if (INV_ACC.test(t)) return null;
    if (!/inverter|microinverter|iq7|iq8|qs1|qt2|ez1|hms-|mac-800/i.test(t)) return null;
    if (!bestVariant(p)) return null;
    var micro = /micro/i.test(t) || p.tags.some(function (x) { return x === 'microinverter' || x === 'microinverters'; });
    if (micro) return 'micro';
    if (/hybrid|all[- ]in[- ]one|18kpv|12000xp|6000xp|off-grid inverter|inverter.?charger|battery[- ]based|storedge/i.test(t)) return 'hybrid';
    if (pt === 'string inverters' || /string|grid[- ]?tie|primo|sma sunny/i.test(t)) return 'string';
    return null;
  }

  function microModules(t) {
    if (/4.?module|4\s?in\s?1|4pv|quad|qs1|qt2|-4t-/i.test(t)) return 4;
    if (/-2t-|ez1/i.test(t)) return 2;
    return 1;
  }

  function invKw(t) {
    var m;
    if ((m = t.match(/(\d{4,5})\s?XP\b/i))) return +m[1] / 1000;      // EG4 12000XP
    if ((m = t.match(/(\d+(?:\.\d+)?)\s?kW\b/i))) return +m[1];        // "12kW"
    if ((m = t.match(/(\d{1,3})K-\dP/i))) return +m[1];                // Sol-Ark 12K-2P
    if ((m = t.match(/SE(\d{1,3})K/i))) return +m[1];                  // SolarEdge SE20K
    if ((m = t.match(/GC(\d{1,3})K/i))) return +m[1];                  // Solis S6-GC25K
    if ((m = t.match(/SCA(\d{1,3})K/i))) return +m[1];                 // Chint SCA25KTL
    if ((m = t.match(/(\d{1,2})KPV/i))) return +m[1];                  // EG4 18kPV
    if ((m = t.match(/(\d{1,3})K\b/i))) return +m[1];                  // fallback "30K"
    return 0;
  }

  function isRacking(p) {
    if (isJunk(p)) return false;
    var pt = (p.pt || '').toLowerCase();
    if (['racking & mounting', 'racking', 'kits', 'solar mounting systems'].indexOf(pt) < 0) return false;
    return !!bestVariant(p);
  }

  function mountOf(p) {
    return /ground|brightmount|power\s?fab|pole\s?mount/i.test(p.title) ? 'ground' : 'roof';
  }

  function isBattery(p) {
    if (isJunk(p)) return false;
    var pt = (p.pt || '').toLowerCase();
    if (['batteries', 'batteries & energy storage', 'solar batteries'].indexOf(pt) < 0) return false;
    var t = p.title.toLowerCase();
    if (/wall mount|mount kit|bracket|wireway|wire way|enclosure|cover\b|busbars?|paralleling cables?|connector|chargeverter|charger\b|lift kit/i.test(t)) return false;
    if (!/battery|batteries|kwh|lifepo4|lfp|agm/i.test(t)) return false;
    return !!bestVariant(p);
  }

  function battKwh(t) {
    var m = t.match(/(\d+(?:\.\d+)?)\s?kWh/i);
    return m ? +m[1] : 0;
  }

  // The catalog contains duplicate listings (same title, different handles).
  // Collapse them at render time so pickers never show the same item twice.
  function dedupeByTitle(arr) {
    var seen = {}, out = [];
    arr.forEach(function (p) {
      var k = p.title.toLowerCase().replace(/\s+/g, ' ').trim();
      if (!seen[k]) { seen[k] = 1; out.push(p); }
    });
    return out;
  }

  /* ---------------- state ---------------- */
  var S = {
    step: 1,
    tier: null, panel: null, panelQty: 12,
    storagePlanned: false, invType: null, inverter: null,
    mount: 'roof', racking: null,
    wantBattery: null, battery: null
  };

  var TIERS = [
    { w: 400, label: '400 W', note: 'Residential sweet spot' },
    { w: 430, label: '430 W', note: 'High-efficiency mono' },
    { w: 450, label: '450 W', note: 'Max watts per roof sqft' },
    { w: 550, label: '550 W', note: 'Commercial / ground' }
  ];

  var money = function (n) {
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var $ = function (id) { return document.getElementById(id); };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------------- step chrome ---------------- */
  var STEP_LABELS = ['', 'Step 1 of 5 — Panels', 'Step 2 of 5 — Inverter', 'Step 3 of 5 — Racking', 'Step 4 of 5 — Storage', 'Step 5 of 5 — Review'];

  function show(n) {
    S.step = n;
    root.querySelectorAll('.pes-kb-step').forEach(function (s) { s.classList.toggle('active', +s.dataset.step === n); });
    var bars = $('kb-progress').children;
    for (var i = 0; i < bars.length; i++) bars[i].classList.toggle('done', i < n);
    $('kb-steplabel').textContent = STEP_LABELS[n];
    if (n === 5) renderReview();
    window.scrollTo({ top: root.offsetTop - 80, behavior: 'smooth' });
  }

  root.querySelectorAll('[data-back]').forEach(function (b) {
    b.addEventListener('click', function () { show(S.step - 1); });
  });

  /* ---------------- item row renderer ---------------- */
  function itemRow(p, opts) {
    var v = bestVariant(p);
    var div = document.createElement('div');
    div.className = 'pes-kb-item';
    div.innerHTML =
      (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy">' : '<img alt="" style="visibility:hidden">') +
      '<div class="meta"><div class="t">' + esc(p.title) +
      (opts.badge ? '<span class="badge' + (opts.badgeWarn ? ' warn' : '') + '">' + esc(opts.badge) + '</span>' : '') +
      '</div><div class="s">' + esc(p.vendor) + (v.sku ? ' · SKU ' + esc(v.sku) : '') + (opts.sub ? ' · ' + esc(opts.sub) : '') + '</div></div>' +
      '<div class="pr"><div class="p">' + money(v.price) + '</div><div class="u">' + esc(opts.unit || '') + '</div></div>';
    div.addEventListener('click', function () {
      div.parentNode.querySelectorAll('.pes-kb-item').forEach(function (x) { x.classList.remove('sel'); });
      div.classList.add('sel');
      opts.onPick(p, v);
    });
    return div;
  }

  /* ---------------- STEP 1: panels ---------------- */
  var tierWrap = $('kb-tiers');
  TIERS.forEach(function (t) {
    var c = document.createElement('div');
    c.className = 'pes-kb-card';
    c.innerHTML = '<span class="ic">🔆</span><span class="lb">' + t.label + '</span><span class="note">' + t.note + '</span>';
    c.addEventListener('click', function () {
      tierWrap.querySelectorAll('.pes-kb-card').forEach(function (x) { x.classList.remove('sel'); });
      c.classList.add('sel');
      S.tier = t.w; S.panel = null;
      $('kb-next-1').disabled = true;
      loadPanels();
    });
    tierWrap.appendChild(c);
  });

  var panelsLoaded = false;
  function loadPanels() {
    var list = $('kb-panel-list');
    list.innerHTML = '';
    $('kb-panel-loading').style.display = 'block';
    $('kb-panel-qtyrow').style.display = 'none';
    DATA.panels.then(function (all) {
      panelsLoaded = true;
      $('kb-panel-loading').style.display = 'none';
      var mine = dedupeByTitle(all.filter(function (p) { return isPanel(p, S.tier); }))
        .sort(function (a, b) { return bestVariant(a).price - bestVariant(b).price; })
        .slice(0, 10);
      if (!mine.length) {
        list.innerHTML = '<div class="pes-kb-empty">No available panels found in this tier right now — try another wattage, or <a href="/pages/quote">send us a quote request</a>.</div>';
        return;
      }
      mine.forEach(function (p) {
        var v = bestVariant(p), w = parseWatts(p.title);
        list.appendChild(itemRow(p, {
          badge: w + 'W',
          sub: 'available',
          unit: money(v.price / w) + '/W',
          onPick: function (pp, vv) {
            S.panel = { p: pp, v: vv, w: w };
            $('kb-panel-qtyrow').style.display = 'flex';
            updateKw();
            $('kb-next-1').disabled = false;
          }
        }));
      });
    });
  }

  function updateKw() {
    if (!S.panel) return;
    var kw = (S.panel.w * S.panelQty / 1000);
    $('kb-kw').textContent = '≈ ' + kw.toFixed(2) + ' kW array · ' + money(S.panel.v.price * S.panelQty) + ' panels';
  }

  $('kb-panel-qty').addEventListener('input', function () {
    S.panelQty = Math.max(1, Math.min(200, +this.value || 1));
    this.value = S.panelQty;
    updateKw();
    if (S.invType === 'micro' && S.inverter) renderInvList(); // refresh micro qty note
  });
  $('kb-qty-minus').addEventListener('click', function () { var i = $('kb-panel-qty'); i.value = +i.value - 1; i.dispatchEvent(new Event('input')); });
  $('kb-qty-plus').addEventListener('click', function () { var i = $('kb-panel-qty'); i.value = +i.value + 1; i.dispatchEvent(new Event('input')); });

  $('kb-next-1').addEventListener('click', function () { show(2); if (!invRendered) renderInvTypes(); });

  /* ---------------- STEP 2: inverter ---------------- */
  var invRendered = false;
  var INV_CARDS = [
    { k: 'micro', ic: '⚡', lb: 'Microinverters', note: 'One per panel — best for shade or complex roofs' },
    { k: 'string', ic: '🔌', lb: 'String inverter', note: 'Single central unit — best value on simple roofs' },
    { k: 'hybrid', ic: '🔋', lb: 'Hybrid (battery-ready)', note: 'Required if you want storage now or later' }
  ];

  function renderInvTypes() {
    invRendered = true;
    var wrap = $('kb-invtypes');
    wrap.innerHTML = '';
    INV_CARDS.forEach(function (c) {
      var disabled = S.storagePlanned && c.k === 'string';
      var rec = (S.storagePlanned && c.k === 'hybrid') || (!S.storagePlanned && c.k === 'micro');
      var d = document.createElement('div');
      d.className = 'pes-kb-card' + (disabled ? ' disabled' : '') + (S.invType === c.k ? ' sel' : '');
      d.innerHTML = (rec ? '<span class="rec">Recommended</span>' : '') +
        '<span class="ic">' + c.ic + '</span><span class="lb">' + c.lb + '</span><span class="note">' + c.note + (disabled ? ' — disabled: storage planned' : '') + '</span>';
      if (!disabled) {
        d.addEventListener('click', function () {
          S.invType = c.k; S.inverter = null;
          $('kb-next-2').disabled = true;
          renderInvTypes();
        });
      }
      wrap.appendChild(d);
    });
    if (S.invType) renderInvList();
  }

  function arrayKw() { return S.panel ? S.panel.w * S.panelQty / 1000 : 0; }

  var invListToken = 0;
  function renderInvList() {
    var list = $('kb-inv-list');
    list.innerHTML = '';
    if (!S.invType) return;
    var token = ++invListToken;
    $('kb-inv-loading').style.display = 'block';
    DATA.inv.then(function (all) {
      if (token !== invListToken) return; // superseded render
      list.innerHTML = '';
      $('kb-inv-loading').style.display = 'none';
      var ak = arrayKw();
      var mine = dedupeByTitle(all.filter(function (p) { return invClass(p) === S.invType; }));
      // de-dupe near-identical titles, sort: sized first, then price
      mine.sort(function (a, b) {
        if (S.invType === 'micro') return bestVariant(a).price - bestVariant(b).price;
        var ka = invKw(a.title), kb = invKw(b.title);
        var sa = ka >= ak * 0.75 && ka <= ak * 2 ? 0 : 1;
        var sb = kb >= ak * 0.75 && kb <= ak * 2 ? 0 : 1;
        return sa - sb || bestVariant(a).price - bestVariant(b).price;
      });
      mine = mine.slice(0, 8);
      if (!mine.length) {
        list.innerHTML = '<div class="pes-kb-empty">No compatible inverters available right now — <a href="/pages/quote">send us a quote request</a> and we\'ll source one.</div>';
        return;
      }
      mine.forEach(function (p) {
        var badge = '', sub = '', unit = '';
        if (S.invType === 'micro') {
          var mpu = microModules(p.title);
          var need = Math.ceil(S.panelQty / mpu);
          badge = mpu > 1 ? mpu + ' panels each' : '1 per panel';
          sub = 'you need ' + need + ' for ' + S.panelQty + ' panels';
        } else {
          var kw = invKw(p.title);
          if (kw) {
            var sized = kw >= ak * 0.75 && kw <= ak * 2;
            badge = kw + ' kW' + (sized ? ' · sized for your array' : '');
          }
          if (S.invType === 'hybrid') sub = 'battery-ready';
        }
        list.appendChild(itemRow(p, {
          badge: badge || undefined,
          badgeWarn: false,
          sub: sub,
          unit: unit,
          onPick: function (pp, vv) {
            S.inverter = { p: pp, v: vv };
            $('kb-next-2').disabled = false;
          }
        }));
      });
    });
  }

  $('kb-storage-toggle').addEventListener('change', function () {
    S.storagePlanned = this.checked;
    if (S.storagePlanned && S.invType === 'string') { S.invType = null; S.inverter = null; $('kb-next-2').disabled = true; }
    renderInvTypes();
  });

  $('kb-next-2').addEventListener('click', function () { show(3); if (!rackRendered) renderMounts(); });

  /* ---------------- STEP 3: racking ---------------- */
  var rackRendered = false;
  var MOUNT_CARDS = [
    { k: 'roof', ic: '🏠', lb: 'Roof mount', note: 'Flush-mount rails, flashings & clamps' },
    { k: 'ground', ic: '🌱', lb: 'Ground mount', note: 'Fixed-tilt ground structures' }
  ];

  function renderMounts() {
    rackRendered = true;
    var wrap = $('kb-mounts');
    wrap.innerHTML = '';
    MOUNT_CARDS.forEach(function (c) {
      var d = document.createElement('div');
      d.className = 'pes-kb-card' + (S.mount === c.k ? ' sel' : '');
      d.innerHTML = '<span class="ic">' + c.ic + '</span><span class="lb">' + c.lb + '</span><span class="note">' + c.note + '</span>';
      d.addEventListener('click', function () {
        S.mount = c.k; S.racking = null;
        $('kb-next-3').disabled = true;
        renderMounts();
      });
      wrap.appendChild(d);
    });
    renderRackList();
  }

  var rackListToken = 0;
  function renderRackList() {
    var list = $('kb-rack-list');
    list.innerHTML = '';
    var token = ++rackListToken;
    $('kb-rack-loading').style.display = 'block';
    DATA.rack.then(function (all) {
      if (token !== rackListToken) return; // superseded render
      list.innerHTML = '';
      $('kb-rack-loading').style.display = 'none';
      var mine = dedupeByTitle(all.filter(function (p) { return isRacking(p) && mountOf(p) === S.mount; }));
      mine.sort(function (a, b) {
        var ka = /kit/i.test(a.title) ? 0 : /rail/i.test(a.title) ? 1 : 2;
        var kb = /kit/i.test(b.title) ? 0 : /rail/i.test(b.title) ? 1 : 2;
        return ka - kb || bestVariant(a).price - bestVariant(b).price;
      });
      mine = mine.slice(0, 8);
      if (!mine.length) {
        list.innerHTML = '<div class="pes-kb-empty">No ' + S.mount + '-mount racking available right now — <a href="/pages/quote">send us a quote request</a>.</div>';
        return;
      }
      mine.forEach(function (p) {
        list.appendChild(itemRow(p, {
          badge: S.mount === 'roof' ? 'roof' : 'ground',
          sub: 'racking & mounting',
          onPick: function (pp, vv) {
            S.racking = { p: pp, v: vv };
            $('kb-next-3').disabled = false;
          }
        }));
      });
    });
  }

  $('kb-next-3').addEventListener('click', function () { show(4); if (!battRendered) renderStorageCards(); });

  /* ---------------- STEP 4: storage ---------------- */
  var battRendered = false;

  function renderStorageCards() {
    battRendered = true;
    var wrap = $('kb-storage-cards');
    wrap.innerHTML = '';
    var cards = [
      { k: false, ic: '☀️', lb: 'No storage', note: 'Grid-tie only — skip the battery step' },
      { k: true, ic: '🔋', lb: 'Add a battery', note: 'Backup power & self-consumption' }
    ];
    cards.forEach(function (c) {
      var d = document.createElement('div');
      d.className = 'pes-kb-card' + (S.wantBattery === c.k ? ' sel' : '');
      d.innerHTML = '<span class="ic">' + c.ic + '</span><span class="lb">' + c.lb + '</span><span class="note">' + c.note + '</span>';
      d.addEventListener('click', function () {
        S.wantBattery = c.k;
        if (!c.k) S.battery = null;
        renderStorageCards();
      });
      wrap.appendChild(d);
    });
    updateStorageStep();
  }

  function updateStorageStep() {
    var warn = $('kb-storage-warn');
    var list = $('kb-batt-list');
    var next = $('kb-next-4');
    warn.style.display = 'none';
    list.innerHTML = '';
    if (S.wantBattery === null) { next.disabled = true; return; }
    if (S.wantBattery === false) { next.disabled = false; return; }
    // wantBattery === true
    if (S.invType !== 'hybrid') {
      // Advisory only: AC-coupled batteries can retrofit onto micro/string
      // systems, so warn and offer the hybrid switch but do NOT block.
      warn.style.display = 'block';
    }
    next.disabled = !S.battery;
    renderBattList();
  }

  $('kb-switch-hybrid').addEventListener('click', function () {
    S.storagePlanned = true;
    $('kb-storage-toggle').checked = true;
    S.invType = 'hybrid'; S.inverter = null;
    $('kb-next-2').disabled = true;
    invRendered = false;
    show(2);
    renderInvTypes();
  });

  var battListToken = 0;
  function renderBattList() {
    var list = $('kb-batt-list');
    list.innerHTML = '';
    var token = ++battListToken;
    $('kb-batt-loading').style.display = 'block';
    DATA.batt.then(function (all) {
      if (token !== battListToken) return; // superseded render
      list.innerHTML = '';
      $('kb-batt-loading').style.display = 'none';
      var mine = dedupeByTitle(all.filter(isBattery));
      var invVendor = S.inverter ? (S.inverter.p.vendor || '').toLowerCase() : '';
      mine.sort(function (a, b) {
        var sa = (a.vendor || '').toLowerCase() === invVendor ? 0 : battKwh(a.title) ? 1 : 2;
        var sb = (b.vendor || '').toLowerCase() === invVendor ? 0 : battKwh(b.title) ? 1 : 2;
        return sa - sb || bestVariant(a).price - bestVariant(b).price;
      });
      mine = mine.slice(0, 10);
      if (!mine.length) {
        list.innerHTML = '<div class="pes-kb-empty">No compatible batteries available right now — <a href="/pages/quote">send us a quote request</a>.</div>';
        return;
      }
      mine.forEach(function (p) {
        var same = (p.vendor || '').toLowerCase() === invVendor && invVendor;
        var kwh = battKwh(p.title);
        list.appendChild(itemRow(p, {
          badge: same ? 'Pairs with your ' + p.vendor : (kwh ? kwh + ' kWh' : '48V'),
          sub: kwh ? kwh + ' kWh usable-class' : 'deep-cycle',
          onPick: function (pp, vv) {
            S.battery = { p: pp, v: vv };
            $('kb-next-4').disabled = false;
          }
        }));
      });
    });
  }

  $('kb-next-4').addEventListener('click', function () { show(5); });

  /* ---------------- STEP 5: review + checkout ---------------- */
  var QTY_OVERRIDE = {};

  function kitLines() {
    var lines = [];
    if (S.panel) lines.push({ role: 'Panels', p: S.panel.p, v: S.panel.v, qty: S.panelQty });
    if (S.inverter) {
      var q = 1;
      if (S.invType === 'micro') q = Math.ceil(S.panelQty / microModules(S.inverter.p.title));
      lines.push({ role: S.invType === 'micro' ? 'Microinverters' : (S.invType === 'hybrid' ? 'Hybrid inverter' : 'String inverter'), p: S.inverter.p, v: S.inverter.v, qty: q });
    }
    if (S.racking) lines.push({ role: S.mount === 'roof' ? 'Roof racking' : 'Ground racking', p: S.racking.p, v: S.racking.v, qty: 1 });
    if (S.wantBattery && S.battery) lines.push({ role: 'Battery', p: S.battery.p, v: S.battery.v, qty: 1 });
    // apply user-edited quantities (keyed by role)
    lines.forEach(function (l) { if (QTY_OVERRIDE[l.role]) l.qty = QTY_OVERRIDE[l.role]; });
    return lines;
  }

  function renderReview() {
    var body = $('kb-review-body');
    body.innerHTML = '';
    var lines = kitLines();
    lines.forEach(function (l, i) {
      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td><span class="role">' + esc(l.role) + '</span></td>' +
        '<td>' + esc(l.p.title) + '<div style="font-size:12px;color:#6b7a86">' + esc(l.p.vendor) + ' · ' + money(l.v.price) + ' ea</div></td>' +
        '<td><input class="rqty" type="number" min="1" max="999" value="' + l.qty + '" data-i="' + i + '"></td>' +
        '<td data-line="' + i + '">' + money(l.v.price * l.qty) + '</td>';
      body.appendChild(tr);
    });
    body.querySelectorAll('.rqty').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var i = +inp.dataset.i;
        var q = Math.max(1, +inp.value || 1);
        var lines2 = kitLines();
        var role = lines2[i] && lines2[i].role;
        if (!role) return;
        QTY_OVERRIDE[role] = q;
        if (role === 'Panels') { S.panelQty = q; $('kb-panel-qty').value = q; updateKw(); }
        lines2 = kitLines();
        refreshTotals(lines2);
      });
    });
    refreshTotals(lines);
  }

  function refreshTotals(lines) {
    var total = 0, count = 0;
    lines.forEach(function (l, i) {
      var cell = document.querySelector('[data-line="' + i + '"]');
      if (cell) cell.textContent = money(l.v.price * l.qty);
      total += l.v.price * l.qty;
      count += l.qty;
    });
    $('kb-total').textContent = money(total);
    $('kb-total-lbl').textContent = 'Kit total · ' + lines.length + ' line items (' + count + ' units)';
  }

  $('kb-checkout').addEventListener('click', function () {
    var lines = kitLines();
    if (!lines.length) return;
    // apply any edited qtys from the visible inputs
    document.querySelectorAll('.rqty').forEach(function (inp) {
      var i = +inp.dataset.i;
      if (lines[i]) lines[i].qty = Math.max(1, +inp.value || 1);
    });
    var parts = lines.map(function (l) { return l.v.id + ':' + l.qty; }).join(',');
    var kw = S.panel ? (S.panel.w * S.panelQty / 1000).toFixed(2) : '';
    var desc = lines.map(function (l) { return l.qty + '× ' + l.p.title; }).join(' | ');
    var note = 'KIT BUILDER — ~' + kw + ' kW ' + (S.invType || '') + (S.wantBattery ? ' + storage' : '') + ' — ' + desc;
    var params = [
      'note=' + encodeURIComponent(note),
      'attributes[Kit source]=Kit builder',
      'attributes[System size]=' + encodeURIComponent('~' + kw + ' kW'),
      'attributes[Inverter type]=' + encodeURIComponent(S.invType || ''),
      'attributes[Mount]=' + encodeURIComponent(S.mount),
      'attributes[Storage]=' + encodeURIComponent(S.wantBattery ? 'yes' : 'no')
    ];
    window.location.href = '/cart/' + parts + '?' + params.join('&');
  });

  // Pre-fill hint for the quote wizard via link context (plain link, no writes).
  $('kb-quote-link').addEventListener('click', function () {
    try {
      var lines = kitLines();
      sessionStorage.setItem('pesKitQuote', JSON.stringify(lines.map(function (l) {
        return { role: l.role, title: l.p.title, sku: l.v.sku, qty: l.qty };
      })));
    } catch (e) {}
  });

  /* ---------------- boot ---------------- */
  show(1);
  window.PESKitBuilder = { state: S, sets: SETS };
})();
